<template>
  <div style="width: 100%; height: 100%;">
    <owal-search-bar
      class="bar"
      :items="roster"
      :callback="searchBarCallback"
      :searchKeys="searchKeys"
      :filters="filters"
      :sorts="sorts"
      />
    <div class="list">
    <virtual-list
      style=""
      :size="65.0"
      :remain="remain"
      :bench="10"
      >
      <credential-mismatch-list-cell
        v-for="(person, index) in filteredRoster"
        :key="index"
        :index="index"
        :name="person.name"
        :matchRatio="person.confidence"
        :wellTrained="true"
        :role="'tenant'"
        :total="person.detections ? person.detections.length : 0"
        :nullMatched="0"
        :lastVerifiedTimestamp="person.lastSeen"
        :identityId="person.credentialUUID"
        :lastSeenUnixTimestamp="person.lastSeenUnixTimestamp"
        :class="currentIdentityIndex === index ? 'selected' : ''"
        @click="handleClick"
        />
    </virtual-list>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import CredentialMismatchListCell from '@/components/credential-mismatch-report/CredentialMismatchListCell'
import VirtualList from 'vue-virtual-scroll-list'
import { OwalSearchBar, OwalFilterPredicate, OwalSortPredicate } from '@/libraries/owal-ui'
import { AutoSizingList } from '@/mixins'

export default {
  name: 'RealtimeRoster',
  components: {
    CredentialMismatchListCell,
    VirtualList,
    OwalSearchBar,
  },
  mixins: [AutoSizingList],
  data () {
    return {
      filters: [
        new OwalFilterPredicate({ displayName: 'All Badges',
          callback: function (object) {
            return true
          } }),
        new OwalFilterPredicate({ displayName: 'Seen',
          callback: function (object) {
            const seen = object.total > 0
            return seen
          } }),
      ],
      searchKeys: ['name'],
      filteredRoster: undefined,
      currentIdentityIndex: undefined,
      sorts: [
        new OwalSortPredicate({ displayName: 'Recent',
          comparisonFunction: function (a, b) {
            const lastSeenA = a.lastSeenUnixTimestamp || 0
            const lastSeenB = b.lastSeenUnixTimestamp || 0
            return lastSeenA - lastSeenB
          } }),
        new OwalSortPredicate({ displayName: 'Match %',
          comparisonFunction: function (a, b) {
            return a.confidence - b.confidence
          } }),
        new OwalSortPredicate({ displayName: 'Taps',
          comparisonFunction: function (a, b) {
            const detA = a.detections ? a.detections.length : -1
            const detB = b.detections ? b.detections.length : -1
            return detB - detA
          } }),
      ],
    }
  },
  computed: {
    ...mapGetters({
      roster: 'realtimeCredentials/roster',
    }),
    remain () {
      return (this.windowHeight - 172) / this.size
    },
  },
  methods: {
    ...mapMutations({
      setIdentityIDFilter: 'realtimeCredentials/setIdentityIDFilter',
    }),
    searchBarCallback (newRoster) {
      this.filteredRoster = newRoster
    },
    handleClick (value) {
      this.currentIdentityIndex = value.index
      this.setIdentityIDFilter(value.identityId)
    },
  },
  mounted () {
    this.filteredRoster = this.roster
  },
}
</script>

<style scoped>
  .selected {
    border-left: 0.4rem solid #beccd8;
  }

  .selected >>> .owal.faces.list.cell.subtitle.right {
    color: #475669 !important;
  }

</style>
